<div class="container main-recargas-container">
    <div class="mt-md-3 p-3">
        <div class="recargas-header">
            <div class="d-flex align-items-center mb-4">
                <button type="button" class="btn btn-outline-secondary btn-sm me-3" 
                        [routerLink]="['/console/credit-option']">
                    <i class="fas fa-arrow-left me-2"></i>Volver al Dashboard
                </button>
                <h5 class="mb-0 text-secondary">
                    <i class="fas fa-mobile-alt me-2"></i>Sistema de Recargas
                </h5>
            </div>
            <p class="recargas-subtitle">
                Gestión integral de recargas telefónicas para operadoras móviles
            </p>
        </div>

        <!-- Router Outlet para navegación progresiva -->
        <router-outlet></router-outlet>
    </div>
</div> 